export const ItemType = {
  DraftIssue: 'DraftIssue',
  Issue: 'Issue',
  PullRequest: 'PullRequest',
  RedactedItem: 'RedactedItem',
  AgentTask: 'MemexAgentTask',
} as const
export type ItemType = ObjectValues<typeof ItemType>
